var USER = 'user';

/**
 * User was loaded
 */
var USER_LOADED = "".concat(USER, "/loaded");

/**
 * User attributes could not be loaded
 */
var USER_LOAD_FAILED = "".concat(USER, "/loadFailed");
export { USER_LOADED, USER_LOAD_FAILED };